import { Collapse } from "antd";
import styled from "styled-components";

export const CharCollapse = styled(Collapse)`
    .ant-collapse-content-box {
        padding-block: 0 !important;
    }
`